import './Page401Config';
import LockIconBlue from '../../../components/icons/svg/LockIconBlue';
import ErrorPage from '../ErrorPage';

const Page401: React.FC = () => (
  <ErrorPage
    translationKey="Page401"
    iconComponent={LockIconBlue}
    pageTitle="401 Page Not Authorized"
    showBoldTitle
    boldTitleText="401"
    titleKey="TITLE_PAGE_401"
    subtitleKey="SUBTITLE_PAGE_401"
    buttonKey="HOME_BUTTON_PAGE_401"
  />
);

export default Page401;
